// extracted by css-extract-rspack-plugin
export default {"wrapper":"BusinessPartnerPickerWithPrefix_wrapper__Tc1Y8","prefix":"BusinessPartnerPickerWithPrefix_prefix__fKld-","picker":"BusinessPartnerPickerWithPrefix_picker__KCPDR"};